<template>
	<div>
		<v-menu :disabled="isDisabled" offset-y>
			<v-btn
				slot="activator"
				color="secondary"
				:disabled="isDisabled"
			>
				<template v-if="isDisabled">No </template>Alternatives <template v-if="!isDisabled">({{ alternatives.length }})</template>
				<v-icon>arrow_drop_down</v-icon>
			</v-btn>
			<v-list>
				<v-list-tile
					class="alternatives-dropdown-item"
					v-for="(alt, index) in alternatives"
					:key="index"
					@click="$emit('update', attr, alt.value)"
				>
					<v-list-tile-content>
						<!-- <v-list-tile-sub-title v-if="$store.get('superUser')">
							<small>{{ alt.source }}</small>
						</v-list-tile-sub-title> -->
						<v-list-tile-title v-html="alt.value"></v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>
		</v-menu>
	</div>
</template>

<script>
import _uniq from 'lodash/uniq';

export default {
	props: {
		attr: { type: String, required: true },
		article: { type: Object, default: null },
	},
	computed: {
		alternatives() {
			const alternatives = this.article.alternatives[this.attr];

			if (this.attr === 'publicationName' && this.article.publication && this.article.publication.name) {
				alternatives.unshift({
					source: 'Global name',
					value: this.article.publication.name,
				});
			}

			// Filtering duplicate values
			const unique = {};
			alternatives.forEach(i => {
				const k = i.value;
				if (!unique[k])
					unique[k] = [];

				unique[k].push(i.source);
			});

			const filtered = [];
			Object.keys(unique).forEach(k => {
				filtered.push({
					source: _uniq(unique[k]).join(', '),
					value: k,
				});
			});

			return filtered;
		},
		isDisabled() {
			return (this.alternatives.length < 2 && this.alternatives[0].value === this.article[this.attr]) || this.article.changing;
		},
	},
}
</script>

<style lang="scss">
.alternatives-dropdown-item {
	.v-list__tile--link {
		padding: 10px 15px;
		height: auto;
		.v-list__tile__title {
			height: auto;
			white-space: normal;

		}
	}
}
</style>

<style scoped>
small {
	text-transform: capitalize;
}
</style>
